export default class AddressViewModel {
  constructor({
    line1,
    line2,
    suburb,
    state,
    postcode,
    country,
    latitude,
    longitude,
    fullAddress,
  } = {}) {
    /**
     * Street address, line 1
     * @type {String}
     * @example '44 Diamond Avenue'
     */
    this.line1 = line1

    /**
     * Street address, line 2
     * @type {String}
     * @example 'Level 14'
     */
    this.line2 = line2

    /**
     * @type {String}
     * @example 'Collingwood'
     */
    this.suburb = suburb

    /**
     * @type {String}
     * @example 'Victoria'
     */
    this.state = state

    /**
     * @type {String}
     * @example '3000'
     */
    this.postcode = postcode

    /**
     * @type {String}
     * @example 'Australia'
     */
    this.country = country

    /**
     * @type {Number}
     * @example 34.51223
     */
    this.latitude = parseFloat(latitude)

    /**
     * @type {Number}
     * @example -145.92812
     */
    this.longitude = parseFloat(longitude)

    /**
     * The combination of all the address parts into a single string
     * @type {String}
     * @example '44 Diamond Avenue Level 14 Collingwood Victoria 3000 Australia'
     */
    this.fullAddress = fullAddress
  }
}
